import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage";
import MainApp from "./MainApp";
import PrivacyPolicy from "./PrivacyPolicy";
import ResourcesIndex from "./ResourcesIndex";
import FloridaSirsRequirements2026 from "./FloridaSirsRequirements2026";
import HowToReadSirsReport from "./HowToReadSirsReport";
import Blog from './Blog';
import BlogSIRSBaselineFunding from './blog/BlogSIRSBaselineFunding';
import BlogBoardLiability from './blog/BlogBoardLiability';
import BlogAssessmentShock from './blog/BlogAssessmentShock';
import BlogDBPRComplianceFines from './blog/BlogDBPRComplianceFines';
import BlogSIRSComponentList from './blog/BlogSIRSComponentList';
import BlogSouthFloridaSIRS from './blog/BlogSouthFloridaSIRS';
import BlogFullFundingVsBaseline from './blog/BlogFullFundingVsBaseline';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/app" element={<MainApp />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/resources" element={<ResourcesIndex />} />
        <Route path="/resources/florida-sirs-requirements-2026" element={<FloridaSirsRequirements2026 />} />
        <Route path="/resources/how-to-read-a-sirs-report" element={<HowToReadSirsReport />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/sirs-baseline-funding-plan-florida" element={<BlogSIRSBaselineFunding />} />
        <Route path="/blog/florida-condo-board-personal-liability-sirs" element={<BlogBoardLiability />} />
        <Route path="/blog/avoid-condo-assessment-shock-south-florida" element={<BlogAssessmentShock />} />
        <Route path="/blog/dbpr-condo-compliance-fines-florida" element={<BlogDBPRComplianceFines />} />
        <Route path="/blog/sirs-component-list-hb-913-florida" element={<BlogSIRSComponentList />} />
        <Route path="/blog/south-florida-sirs-miami-dade-broward" element={<BlogSouthFloridaSIRS />} />
        <Route path="/blog/full-funding-vs-baseline-sirs-florida" element={<BlogFullFundingVsBaseline />} />
      </Routes>
    </BrowserRouter>
  );
}
